import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import { LogoThemeProvider } from './context/LogoThemeContext';

import Home from './pages/Home';
import About from './pages/About';
import ForlobPage from './pages/ForlobPage';
import ForbundetFraHjertetPage from './pages/ForbundetFraHjertetPage';
import EnRejseHjemPage from './pages/EnRejseHjemPage';
import LytFraHjertetPage from './pages/LytFraHjertetPage';
import AstrologiPage from './pages/AstrologiPage';
import ContactPage from './pages/ContactPage';
import ForbiddenPage from './pages/ForbiddenPage';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <HelmetProvider>
      <LogoThemeProvider>
        <ScrollToTop />
        <div className="flex flex-col min-h-screen bg-[#FAF7F2] text-[#2E2A27] font-sans antialiased">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/om-lenea-evolinee" element={<About />} />
              <Route path="/om-zentai" element={<About />} />
              <Route path="/forlob" element={<ForlobPage />} />
              <Route path="/forbundet-fra-hjertet" element={<ForbundetFraHjertetPage />} />
              <Route path="/forlob/forbundet-fra-hjertet" element={<ForbundetFraHjertetPage />} />
              <Route path="/1-1-forlob" element={<EnRejseHjemPage />} />
              <Route path="/1-1-forløb" element={<EnRejseHjemPage />} />
              <Route path="/forlob/1-1-forlob" element={<EnRejseHjemPage />} />
              <Route path="/forlob/1-1-forløb" element={<EnRejseHjemPage />} />
              <Route path="/lyt-fra-hjertet" element={<LytFraHjertetPage />} />
              <Route path="/forlob/lyt-fra-hjertet" element={<LytFraHjertetPage />} />
              <Route path="/forbundet-med-dit-horoskop" element={<AstrologiPage />} />
              <Route path="/forlob/forbundet-med-dit-horoskop" element={<AstrologiPage />} />
              <Route path="/astrologi-fra-hjertet" element={<AstrologiPage />} />
              <Route path="/forlob/astrologi-fra-hjertet" element={<AstrologiPage />} />
              <Route path="/astrologisk-1-1-session" element={<AstrologiPage />} />
              <Route path="/forlob/astrologisk-1-1-session" element={<AstrologiPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/403" element={<ForbiddenPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </LogoThemeProvider>
    </HelmetProvider>
  );
}
